import { smoothScroll } from './utils/utils'
import fancybox from '@fancyapps/fancybox'
import axios from 'axios'
import gsap from 'gsap'

const HTML = document.querySelector('html');

class App {

	constructor() {

		// Back top
		let backtop = document.querySelector('.back-top');
		if( backtop ) {
			backtop.addEventListener('click', (e) => {
				e.preventDefault();

				gsap.to( 
					document.querySelectorAll('html, body'),
					{
						duration : .8,
						scrollTop : 0,
						ease : "circ.inOut"
					}
				)

			})
		}

		// Fancybox
		jQuery('[data-fancybox]').fancybox({
			transitionEffect: "zoom",
			buttons: [
				'close'
			],
			btnTpl: {
				close: 
					'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g id="close" transform="translate(0.025 0.025)"><path id="Tracé_111" data-name="Tracé 111" d="M.392,19.558h0a1.427,1.427,0,0,1,0-2.016L17.542.392a1.427,1.427,0,0,1,2.016,0h0a1.427,1.427,0,0,1,0,2.016L2.408,19.558A1.427,1.427,0,0,1,.392,19.558Z" transform="translate(0 0)" fill="#fff"/><path id="Tracé_112" data-name="Tracé 112" d="M.392.392h0a1.427,1.427,0,0,1,2.016,0L19.554,17.538a1.427,1.427,0,0,1,0,2.016h0a1.427,1.427,0,0,1-2.016,0L.392,2.408A1.427,1.427,0,0,1,.392.392Z" transform="translate(0 0)" fill="#fff"/></g></svg>' +
					'</button>',
				arrowLeft: 
					'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
					'<div><svg xmlns="http://www.w3.org/2000/svg" width="15" height="27.627" viewBox="0 0 15 27.627"><path id="chevron-left-white" d="M128.109,27.676a1.191,1.191,0,0,0,.851-2.022L117.168,13.668,128.944,2.085a1.188,1.188,0,0,0-1.663-1.7L114.654,12.806a1.175,1.175,0,0,0-.354.84,1.21,1.21,0,0,0,.343.845l12.627,12.831A1.158,1.158,0,0,0,128.109,27.676Z" transform="translate(-114.3 -0.049)" fill="#fff"/></svg></div>' + 
					'</button>',
				arrowRight:
					'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
					'<div><svg xmlns="http://www.w3.org/2000/svg" width="15" height="27.627" viewBox="0 0 15 27.627"><path id="chevron-right-white" d="M115.44,27.676a1.191,1.191,0,0,1-.851-2.022l11.792-11.986L114.606,2.085a1.188,1.188,0,1,1,1.663-1.7L128.9,12.806a1.175,1.175,0,0,1,.354.84,1.21,1.21,0,0,1-.343.845L116.285,27.322A1.18,1.18,0,0,1,115.44,27.676Z" transform="translate(-114.249 -0.049)" fill="#fff"/></svg></div>' + 
					'</button>'
			}
		});

		// Button load more
		let loadmore = document.querySelector('.load-more a');
		if( loadmore ) {
			let container = document.querySelector('.news__container')
			loadmore.addEventListener('click', (e) => {
				e.preventDefault();
				loadmore.classList.add('loading')

		    axios({
		      method: 'get',
		      url: loadmore.href,
		    })
		    .then(function (response) {
		    	loadmore.classList.remove('loading')

		    	if( response.data) {
		    		let html = document.createElement('div')
		    		html.innerHTML = response.data;

		    		// On ajoute la page suivante
		    		let childs = html.querySelector('.news__container').children
		    		for(var i = 0; i < childs.length; i++) {
		    			container.appendChild(childs[i].cloneNode(true));
		    		}

		    		// On met à jour le bouton load more
		    		let next = html.querySelector('.load-more a');
		    		if( next ) 
		    			loadmore.href = next.href
		    		else 
		    			loadmore.classList.add('hidden')

		    	}
		    })
			})
		}

		return this
	}

}


window.addEventListener('load', function() {
	new App();
});